import type { TextUIPart } from '@ai-sdk/ui-utils';
import type { ScrollToBottom } from 'use-stick-to-bottom';
import { Markdown } from '~/components/chat/Markdown';
import { CC_MAGIC_STRING_REGEX } from '~/utils/constants';

interface TextProps {
  part: TextUIPart;
  scrollToBottom?: ScrollToBottom;
}

export function Text({ part, scrollToBottom }: TextProps) {
  let text = part.text;

  if (CC_MAGIC_STRING_REGEX.test(text)) {
    text = text.replace(CC_MAGIC_STRING_REGEX, '');
  }

  if (!text.trim()) {
    return null;
  }

  return (
    <Markdown html scrollToBottom={scrollToBottom}>
      {text}
    </Markdown>
  );
}
